var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.injection_bulk") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { attrs: { slot: "pageContent" }, slot: "pageContent" },
          [
            _c(
              "b-container",
              { attrs: { fluid: "" } },
              [
                _c(
                  "form-accordion",
                  {
                    attrs: {
                      toggleActive: false,
                      title: _vm.$t("tracking.general_information"),
                      isTitleUpperCase: false,
                    },
                  },
                  [
                    _c(
                      "b-row",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-center",
                      },
                      [
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                isMandatory: "",
                                inputLabel: _vm.$t("tracking.name"),
                                placeholderValue: _vm.$t("tracking.name"),
                              },
                              model: {
                                value: _vm.form.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "name", $$v)
                                },
                                expression: "form.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "form-group d-flex flex-column",
                            attrs: { sm: "6" },
                          },
                          [
                            _c("span", [
                              _c("span", { staticClass: "filter-item-title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("tracking.tracking_file"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v("* "),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              attrs: { type: "file", accept: ".csv" },
                              on: { change: _vm.handleFileUpload },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "mt-3 justify-content-end" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "4", lg: "2", xl: "1" } },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              disabled:
                                !_vm.form.name === "" || _vm.base64Data === "",
                            },
                            on: { click: _vm.importTrackingFile },
                          },
                          [
                            _c("i", { staticClass: "fa-light fa-save" }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }